<script>
  import PlayerAvatar from '@/components/Player/PlayerAvatar'

  export default {
    props: {
      comment: {
        type: Object,
        required: true
      }
    },

    components: {
      PlayerAvatar
    },

    data() {
      return {
        visible: true,
        loading: false,
        plink: {
          name: 'player',
          params: {
            id: this.comment.user.player.slug
          }
        },
        editing_comment: false,
        new_comment: null
      }
    },

    computed: {
      html_content() {
        return this.$linkifyStr(this.comment.content)
      }
    },

    methods: {
      save(comment) {
        if (this.loading) {
          return
        }

        const url = '/hits/' + comment.commentable_id + '/comments/' + comment.id
        const content = this.new_comment

        this.loading = true
        this.axios.put(url, {content})
        .then(() => {
          this.$emit('updated')
          this.cancel()
          this.comment.content = content
        })
        .finally(() => (this.loading = false))
      },

      editComment(comment) {
        this.editing_comment = true
        this.new_comment = comment.content
      },

      cancel() {
        this.new_comment = null
        this.editing_comment = false
      },

      deleteComment(comment) {
        if (this.loading) {
          return
        }

        if (!confirm(this.$t('comment.delete_sure'))) {
          return
        }

        const url = '/hits/' + comment.commentable_id + '/comments/' + comment.id

        this.loading = true
        this.axios.delete(url)
        .then(() => {
          this.$emit('deleted')
          this.visible = false
        })
        .finally(() => (this.loading = false))
      }
    }
  }
</script>

<template>
  <article class="comment-box media" v-if="visible">
    <router-link class="media-left" :to="plink" tag="div">
      <player-avatar class="comment-box_user-image" :player="comment.user.player"/>
    </router-link>

    <div class="media-content" v-if="!editing_comment">
      <div class="content">
        <p>
          <router-link class="comment-box_user-name" :to="plink" tag="strong">
            {{ comment.user.player.name }}
          </router-link>
          -
          <small class="comment-box_date">
            {{ comment.created_at | moment("from", "now") }}
          </small>
        </p>
        
        <p class="comment-box_text" v-html="html_content"></p>
      </div>
      <p class="comment-box_toolbar content" v-if="user.id === comment.user_id">
        <button class="button is-text is-text-danger" @click="editComment(comment)">
          {{ $t('buttons.edit') }}
        </button>
        <button class="button is-text is-text-danger" @click="deleteComment(comment)">
          {{ $t('buttons.delete') }}
        </button>
      </p>
    </div>

    <form class="comment-form media-content" @submit.prevent="save(comment)" v-if="editing_comment">
      <div class="control" :class="{'is-loading': loading}">
        <textarea class="textarea is-open-big" :placeholder="$t('fields.add_comment')" v-model.trim="new_comment"></textarea>
        
        <div class="comment-form_actions">
          <button class="button is-primary"
            :class="{'is-loading': loading}"
            v-show="new_comment"
            type="submit">
            {{ $t('buttons.send') }}
          </button>
          <button class="button is-danger" type="button" @click="cancel">
            {{ $t('buttons.cancel') }}
          </button>
        </div>
      </div>
    </form>
  </article>
</template>

<style lang="scss">
  .comment-box {
    &_user-image,
    &_user-name {
      cursor: pointer;
    }

    .media-content p {
      &:first-child {
        margin-bottom: 0;
      }
    }

    &_text {
      word-wrap: break-word;
      word-break: break-word;
      white-space: pre-wrap;
    }

    &_toolbar {
      margin: 0 pxToEm(-20);
      text-align: right;
    }

    &_toolbar .button,
    .comment-form .button {
      padding: 0 pxToEm(10);
      font-size: $font-size-s;
    }
  }
</style>



// WEBPACK FOOTER //
// HitComment.vue?0b9edc72